(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.boxi.controller
  (:require
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.controller :as pe-controller]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn- esg
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  (let [{:keys [esg]} report-data]
    {:esg-targets-and-strategy-text (report-ctl/rich-content props
                                                             :esg-targets-and-strategy-text)
     :key-perf-indicators (->> (report-ctl/with-footnote props
                                                    :key-perf-indicators-footnotes
                                                    esg)
                               (report-ctl/with-editable-tables props :key-perf-indicators
                                                                pe-controller/raw-data->editable-data
                                                                pe-controller/editable-data->raw-data))
     :gresb (get-in report-data [:esg :gresb])
     :incidents-text (report-ctl/rich-content props :incidents-text)}))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name           (:fund-name report-data)
   :reference-date      (get-in report-data [:reference-date])
   :tearsheet           (pe-controller/tearsheet-ui-data
                         (update props :dynamic-path concat [:tearsheet]))
   :overview            (pe-controller/overview-ui-data
                         (update props :dynamic-path concat [:overview]))
   :details-and-figures (pe-controller/details-and-figures-ui-data
                         (update props :dynamic-path concat [:details-and-figures]))
   :investors           (report-ctl/with-footnote props
                                                  :investors-footnotes
                                                  (:investors report-data))
   :esg                 (esg (update props :dynamic-path concat [:esg]))
   :summaries           {:fee-summary       (report-ctl/with-footnote
                                             props
                                             :fee-summary-footnotes
                                             (:fee-summary report-data))
                         :finance-summary   (report-ctl/with-footnote
                                             props
                                             :finance-summary-footnotes
                                             (:finance-summary report-data))
                         :finance-summary-2 (report-ctl/with-footnote
                                             props
                                             :finance-summary-2-footnotes
                                             (:finance-summary-2 report-data))}})
